import { Button as DSButton } from '@backend/lib-design-system';
import { styled } from 'styled-components';

export const Button = styled(DSButton)<{ $isProman?: boolean }>`
  padding: 0.75rem 1rem;
  border-radius: 1.5rem;
  z-index: 0;
  ${({ $isProman }) =>
    $isProman &&
    `
    background: #F58220 !important;
    &:hover {
      background-color: white !important;
      svg, path {
        color: #F58220 !important;
      }
    }
    &:active, &:hover {
      background-color: white !important;
      svg, path {
        color: #F58220 !important;
      }
    }
  `}
`;
